import Model from '../utils/Model'
import CommonState from '@/class/cargo/model/parameters/CommonState'

export default class SopConstants {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

/**
 * 数据服务
 * @type {SopConstants}
 */
export const DATA_SERVICE_SHIP_PLANNING = new SopConstants(1, 'Ship planning at the port of departure', '起运港船舶计划')
export const DATA_SERVICE_CONTAINER_TRACKING = new SopConstants(2, 'Container tracking', '箱货跟踪')
export const DATA_SERVICE_SHIP_DYNAMICS = new SopConstants(3, 'Ship dynamics at the port of destination', '目的港船舶动态')

export const DATA_SERVICES = [DATA_SERVICE_SHIP_PLANNING, DATA_SERVICE_CONTAINER_TRACKING, DATA_SERVICE_SHIP_DYNAMICS]

export const AI_IS_STUFFY_TYPE = new CommonState('IS', '仓储', 'Storage')
export const AI_DD_STUFFY_TYPE = new CommonState('DD', '门点送货', 'Delivery to Door')

/**
 * 本地服务
 */
export const AI_SUFFY_TYPES = ([
  AI_IS_STUFFY_TYPE,
  AI_DD_STUFFY_TYPE
])

export const RE_IS_STUFFY_TYPE = new CommonState('IS', '内装箱/仓储', 'CFS/Storage')
export const RE_DD_STUFFY_TYPE = new CommonState('DD', '门点装箱/提货', 'Door/Delivery')
export const RE_SD_STUFFY_TYPE = new CommonState('SD', '自拉自送', 'Auto Truck and Load')

/**
 * 本地服务
 */
export const RE_SUFFY_TYPES = ([
  RE_IS_STUFFY_TYPE,
  RE_DD_STUFFY_TYPE,
  RE_SD_STUFFY_TYPE
])

export const SWITCH_OPEN = new CommonState(1, '开启', 'Open')
export const SWITCH_CLOSE = new CommonState(0, '关闭', 'Close')

/**
 * 开启关闭
 */
export const SWITCH = ([
  SWITCH_OPEN,
  SWITCH_CLOSE
])

/**
 *  return null:没找到.
 */
export function getDataServiceByCode(code) {
  return Model.getObjByCode(code, DATA_SERVICES)
}
